import axios from 'axios';
import appConfig from '../config/index';
// default
axios.defaults.baseURL = appConfig.API_URL;
// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(
  (config) => {
    const storedUser = JSON.parse(localStorage.getItem('technisches'));
    if (storedUser?.expiresAt && new Date(storedUser.expiresAt).getTime() <= Date.now()) {
      localStorage.removeItem('technisches');
      window.location.reload();
      return config;
    }
    const token = storedUser?.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Sets the default authorization
 * @param {*} token
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('technisches');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// const setAuthorization = (token) => {
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// };

class APIClient {
  // eslint-disable-next-line class-methods-use-this
  get = (url, params) => {
    let response;

    const paramKeys = [];
    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(`${key}=${params[key]}`);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : '';
      response = this.axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(url);
    }
    return response;
    // return axios.get(url, { params });
  };

  // eslint-disable-next-line class-methods-use-this
  create = (url, data, headers) => axios.post(url, data, headers);

  // eslint-disable-next-line class-methods-use-this
  update = (url, data, headers) => axios.put(url, data, headers);

  // eslint-disable-next-line class-methods-use-this
  delete = (url, params, headers) => axios.delete(url, { params }, headers);
}
const getLoggedinUser = () => {
  const user = localStorage.getItem('technisches');

  if (!user) {
    return null;
  }
  return JSON.parse(user);
};

export { APIClient, getLoggedinUser };
